import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAllProduct, UpdateProductStatus } from "../../services/productService";
import { handleStatusToggle } from "../../common/handleStatusToggle";

const ProductList = () => {
  const navigate = useNavigate();

  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await GetAllProduct();

        // If your service returns response.data
        if (response?.statusCode === 200 && response?.success) {
          setProductData(response.data || []);
          setError("");
        } else {
          setError(response?.message || "Something went wrong.");
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

 const handleStatusChange = (id, checked) => {
  handleStatusToggle({
    id,
    checked,
    data: productData,
    setData: setProductData,
    updateApi: UpdateProductStatus,
  });
};
  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Product List</h4>
        </div>

        <div className="card-body">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">
                  Total Records
                  <span className="badge bg-primary ms-2">
                    {productData.length}
                  </span>
                </h5>

                <button
                  className="btn btn-success"
                  onClick={() => navigate("/addproduct")}
                >
                  + Add New Product
                </button>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Product Name</th>
                      <th>SKU</th>
                      <th>Origin Price</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {productData.length > 0 ? (
                      productData.map((product, index) => (
                        <tr key={product.id}>
                          <td>{index + 1}</td>
                          <td>{product.name}</td>
                          <td>{product.sku}</td>
                          <td>₹{product.originPrice}</td>

                        <td>
  <div className="form-check form-switch">
    <input
      className="form-check-input"
      type="checkbox"
      checked={product.isActive}
      onChange={(e) =>
        handleStatusChange(product.id, e.target.checked)
      }
    />
    <label className="form-check-label">
      {product.isActive ? "Active" : "Inactive"}
    </label>
  </div>
</td>

                          <td>
                            <button
                              className="btn btn-warning btn-sm"
                              onClick={() =>
                                navigate(`/addproduct/${product.id}`)
                              }
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductList;